import React, { useState } from 'react';
import { Form } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import Modal from '@rd-web-markets/shared/dist/util/Modal';
import { handleError } from '@rd-web-markets/shared/dist/store/features/alertSlice';
import notesAndAssumptionsService from './notesAndAssumptions/notesAndAssumptions.service';
const CreateNoteModal = _ref => {
  let {
    show,
    onHide,
    claimId,
    category
  } = _ref;
  const {
    t
  } = useTranslation();
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({
    comments: '',
    expenditure_category: category || ''
  });
  const {
    createNote
  } = notesAndAssumptionsService.useCrud(setLoading, claimId);
  const handleChange = e => {
    const {
      name,
      value
    } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };
  const handleSubmit = async () => {
    if (!formData.comments.trim()) {
      dispatch(handleError({
        message: t('comments_required')
      }));
      return;
    }
    await createNote(formData);
    setFormData({
      comments: '',
      expenditure_category: category || ''
    });
    onHide();
  };
  const getCategoryLabel = cat => {
    return t(cat);
  };
  const renderBody = () => {
    return /*#__PURE__*/React.createElement("div", {
      className: "p-3"
    }, /*#__PURE__*/React.createElement(Form.Group, {
      controlId: "category",
      className: "mb-3"
    }, /*#__PURE__*/React.createElement(Form.Label, null, t('category')), /*#__PURE__*/React.createElement(Form.Control, {
      type: "text",
      value: getCategoryLabel(formData.expenditure_category),
      disabled: true,
      readOnly: true
    })), /*#__PURE__*/React.createElement(Form.Group, {
      controlId: "comments",
      className: "mb-3"
    }, /*#__PURE__*/React.createElement(Form.Label, null, t('comments'), " *"), /*#__PURE__*/React.createElement(Form.Control, {
      as: "textarea",
      rows: 5,
      name: "comments",
      value: formData.comments,
      onChange: handleChange,
      placeholder: t('enter_comments'),
      disabled: loading
    })));
  };
  return /*#__PURE__*/React.createElement(Modal, {
    size: "lg",
    title: t('add_note'),
    show: show,
    renderBody: renderBody,
    onHide: onHide,
    onSubmit: handleSubmit,
    submitDisabled: loading || !formData.comments.trim(),
    submitText: loading ? t('saving') : t('create')
  });
};
export default CreateNoteModal;